import { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { CheckCircleIcon } from "@heroicons/react/outline";
import { useTranslation } from "react-i18next";
import CenteredModal from "./CenteredModal";
type ConfirmationModalProps = {
  email: string;
  isOpen: boolean;
  onClose: () => void;
  btnText: string;
};
export default function ConfirmationModal(props: ConfirmationModalProps) {
  const { email, isOpen, onClose, btnText } = props;

  const LocalBasePath = "page.candidate.dashboard.schedule";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });

  return (
    <CenteredModal setOpen={onClose} open={isOpen}>
      <Dialog.Panel className="p-2  overflow-hidden  bg-white  sm:w-full sm:max-w-sm">
        <div>
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-lg bg-teal-50">
            <CheckCircleIcon
              className="h-6 w-6 text-teal-700"
              aria-hidden="true"
            />
          </div>
          <div className="mt-3 text-center">
            <p className="text-base text-gray-500">
              {t("confirmSend", { email })}
            </p>
          </div>
        </div>
        <div className="mt-3">
          <button
            type="button"
            className="mx-auto flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-brandblue-600 hover:bg-brandblue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandblue-500"
            onClick={() => onClose()}
          >
            {t(btnText)}
          </button>
        </div>
      </Dialog.Panel>
    </CenteredModal>
  );
}
